export default {
	approveCreateNewTask: 'Úkol se úspěšně vytvořil.',
	approveCreateNewLead: 'Příležitost se úspěšně vytvořila.',
	approveFeedbackHeader: 'Zpětná vazba byla úspěšně uložena. Úkol najdete v záložce Zpracované.',
	approveNonSuccessfulTypeFeedbackUpdate: 'Zpětná vazba byla úspěšně uložena.',
	approveProcessInfoHeader: 'Úkol najdete v záložce zpracované.',
	errorFeedbackHeader: 'Nastala chyba, spětná vazba nebyla uložena',
	errorProcessInfoHeader: 'Nastala chyba, vybrané informace nebyly uloženy',
	approveFeedbackMessage: 'Úkol najdete v záložce zpracované',
	approveTextHeader: 'Poznámka byla uložena',
	errorTextHeader: 'Nastala chyba, poznámka nebyla uložena',
	approveTextMessage: 'Je možné zadat další poznámku',
	approveTakeMessage: 'Převzali jste vybraný úkol.',
	approveSaveCampaign: 'Kampaň byla úspěšně uložena',
	approveSaveGuarantors: 'Garanti regionu byli uloženi.',
	approveCampaignContactStates: 'Stavy byly úspěně uloženy',
	approveCampaignAdditionalData: 'Doplňující data byla úspěšně uložena.',
	errorTakeMessage: 'Vyskytla se chyba, nepřevzali jste vybraný úkol.',
	approveSaveUserFilters: 'Nastavení informací bylo změněno.',
	errorSaveUserFilters: 'Nastala chyba, nastavení informací nebylo změněno.',
	approveInformationProccessed: 'Vybrané informace byly úspěšně zpracované. Informace najdete v záložce Zpracované.',
	warningInformationProccessed:
		'Některá z označených informací se nezpracovala, protože byla mezitím zpracována nebo již nejste jejím řešitelem.',
	approveResetStartupCurve: 'Hodnoty náběhové křivky byly vynulovány.',
	approveSaveStartupCurve: 'Náběhová křivka je uložena.',
	approveTaskRedirect: 'Vybrané úkoly/informace byly úspěšně předány.',
	approveSendTaskCopyEmail: 'Kopie úkolu byla odeslána na zadanou adresu',
	approveErrorReset: 'Seznam chyb byl smazán.',
	approveSettingsReset: 'Nastavení kampaně bylo úspěšně vymazáno',
	approveTemplateSave: 'Šablona byla v pořádku uložena.',
	approveDeleteDocument: 'Dokument byl úspěšně vymazán',
	templateReadSucceeded: 'Šablona byla v pořádku načtena',
	approveTakeContact: 'Kontakt byl úspěšně převzat',
	approveNominationSave: 'Nominace byly v pořádku uloženy',
	contactOrderSave: 'Vaše změny byly uloženy',
	approveSaveDocument: 'Dokument byl úspěšně uložen.',
	raAnalysisSuccessfulHandover: 'Vybrané analýzy byly úspěšně předány.',
	raAnalysisUnsuccessfulHandover: 'Některé z označených analýz se nepodařilo úspěšně předat.',
	campaignSettingsDeleteContactsSuccess: 'Kontakty byly úspěšně vráceny.',
	semaphoreFeedbackDetailUpdated: 'Změny byly uloženy',
	marketPlaceSuccessfulyTakeLead: 'Příležitost byla v pořádku převzata. Naleznete ji v sekci Moje příležitosti.',
	marketPlaceLeadAlreadyTaken: 'Vybraná příležitost již byla převzata jiným obchodníkem.',
	marketPlaceLeadFeedbackProcessedSuccessfully: 'Zpětná vazba byla úspěšně zadána.',
	cannotAddKoprFeedbackProductionAlreadyClosed: 'Případ byl již uzavřen, není možné zadat zpětnou vazbu.',
	cannotUpdateContactFeedbackUserIsNotResolver: 'Nelze zpracovat kontakt, protože již nejste jeho řešitelem.',
	infoOrTaskAlreadyResolved: 'Informace/úkol je již splněn.',
	cannotProcessInfoTaskUserIsNotResolver: 'Nelze zpracovat informaci/úkol, protože již nejste jeho řešitelem.',
	infoAlreadyProcessed: 'Nelze zpracovat informaci/úkol, protože již byla mezitím zpracována.',
	marketPlaceLeadAlreadyProcessed: 'Příležitost již byla splněna.',
	taskRedirectErrorUserNotResolver: 'Nelze předat informaci/úkol, protože již nejste jejím řešitelem.',
	taskRedirectErrorAlreadyProcessed: 'Nelze předat informaci/úkol, protože byla již zpracována.',
	takeTaskErrorUserHasNoAccess: 'Na převzetí informace/úkolu již nemáte práva.',
	takeTaskErrorAlreadyProcessed: 'Nelze převzít informaci/úkol, protože byla již zpracována.',
	contactDetailErrorUserNotResolver: 'Nelze zobrazit detail kontaktu, protože nejste jeho řešitelem.',
	taskDetailErrorUserNotResolver: 'Nelze zobrazit detail úkolu/informace, protože nejse jeho řešitelem.',
	leadDetailErrorUserNotResolver: 'Nelze zobrazit detail příležitosti, protože nejste jejím řešitelem.',
};
